import {
    STATE_FAIL,
    STATE_LOADING,
    STATE_SUCCESS,
} from '../constants/state.constants';

export const ReducerHelpers = {
    loading,
};

function loading(
    state: string | null = null,
    action: { type: string },
    type: string | string[],
) {
    if (Array.isArray(type)) {
        for (const i in type) {
            const current = type[i];

            const result = reduce(current);

            if (result) {
                return result;
            }
        }

        return state;
    }

    return reduce(type) || state;

    function reduce(_type: string) {
        switch (action.type) {
            case _type:
                return STATE_LOADING;
            case `${_type}_SUCCESS`:
                return STATE_SUCCESS;
            case `${_type}_FAIL`:
                return STATE_FAIL;
            default:
                return null;
        }
    }
}
